module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-lg-8"
  }, [_c('h5', [_vm._v(_vm._s(_vm.graphTitle))]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "col col-lg-4"
  }, [_c('h5', [_vm._v("Time period and filters")]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Time period :")]), _vm._v(" "), _c('b-form-select', {
    staticClass: "custom-select",
    attrs: {
      "required": "",
      "options": _vm.periodOptions
    },
    on: {
      "change": function($event) {
        return _vm.$emit('fetch-periode', _vm.sPeriod)
      }
    },
    model: {
      value: (_vm.sPeriod),
      callback: function($$v) {
        _vm.sPeriod = $$v
      },
      expression: "sPeriod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Filter by IBAN :"
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.ibanOptions
    },
    model: {
      value: (_vm.sIbans),
      callback: function($$v) {
        _vm.sIbans = $$v
      },
      expression: "sIbans"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Filter by contact :"
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.contactOptions
    },
    model: {
      value: (_vm.sContacts),
      callback: function($$v) {
        _vm.sContacts = $$v
      },
      expression: "sContacts"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('b-button', {
    on: {
      "click": function($event) {
        return _vm.$emit('filter-graph', {
          ibans: _vm.sIbans,
          contacts: _vm.sContacts
        })
      }
    }
  }, [_vm._v("Filter")]), _vm._v(" "), _c('b-button', {
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v("Clear Filter")]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.trueValueLabel && _vm.falseValueLabel) ? _c('b-form-group', {
    attrs: {
      "label": "Displayed Data :"
    }
  }, [_c('b-form-radio-group', _vm._l((_vm.showOptions), function(option) {
    return _c('b-form-radio', {
      key: option.value,
      attrs: {
        "value": option.value
      },
      model: {
        value: (_vm.showing),
        callback: function($$v) {
          _vm.showing = $$v
        },
        expression: "showing"
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-09149894", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09149894","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/statistics/components/GraphPanel.vue
// module id = 1616
// module chunks = 2